import React from 'react';
import { IconSun, IconMoon } from '@tabler/icons-react';
import { useTheme } from '../../../contexts/theme/ThemeContext';

const ThemeToggleIcon = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  return (
    <button
      onClick={toggleDarkMode}
      className="w-full p-3 hover:bg-glass-bg-hover flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
      aria-label="Toggle theme"
      title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDarkMode ? (
        <IconSun size={24} className="text-warning" />
      ) : (
        <IconMoon size={24} className="text-text-secondary" />
      )}
    </button>
  );
};

export default React.memo(ThemeToggleIcon);
